export default __webpack_public_path__ + "static/video1-d1a44f3ed14c26464f396e4be70a7cd0.mp4";